import { FC } from 'react'
import { makeStyles } from 'tss-react/mui'
import Typography from '@mui/material/Typography'
import { InterestedOrganizationsTable } from '../organisms'
import Alert from '@mui/material/Alert'
import { theme } from '../../lib/styles/universal'
import { InterestedOrganizationAdmin } from '@hazadapt-git/public-core-base'
import { LoadingView } from '../molecules'

interface InterestedOrganizationsPageTemplateProps {
    submissions: InterestedOrganizationAdmin[]
    isLoading: boolean
    error: string | null
    onSaveNotes: (
        id: string,
        payload: { internal_notes: string | null }
    ) => Promise<void>
}

export const InterestedOrganizationsPageTemplate: FC<InterestedOrganizationsPageTemplateProps> = ({
    submissions,
    isLoading,
    error,
    onSaveNotes,
}) => {
    const { classes: localClasses } = useLocalStyles()

    return (
        <div className={localClasses.container}>
            <Typography variant="h2" component="h1">
                Interested Organizations
            </Typography>
            {error ? (
                <Alert severity="error">{error}</Alert>
            ) : isLoading ? (
                <LoadingView fullscreen={false} />
            ) : (
                <InterestedOrganizationsTable
                    submissions={submissions}
                    onSaveNotes={onSaveNotes}
                />
            )}
        </div>
    )
}

const useLocalStyles = makeStyles()({
    container: {
        display: 'flex',
        flexDirection: 'column',
        gap: '1.5rem',
        padding: '1rem',
        width: '100%',
        minHeight: 'calc(100dvh - 9.25rem)',
        [theme.breakpoints.up('md')]: {
            minHeight: '100dvh',
        },
    },
})
